import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const TypographyCellCC = styled(Typography)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
})

export default TypographyCellCC